"use client"

import React, { useState } from 'react'; // Ensure correct import
import AppBarMenu from '../AppBarMenu/AppBarMenu';

function DropDown({ heading, label, items }) {
  const [isOpen, setIsOpen] = useState(false);

  const handleMouseEnterButton = () => {
    setIsOpen(true);
  };

  const handleMouseLeaveButton = () => {
    setTimeout(() => setIsOpen(false), 20);
  };

  const handleMouseEnterMenu = () => {
    setIsOpen(true);
  };

  const handleMouseLeaveMenu = () => {
    setTimeout(() => setIsOpen(false), 20);
  };

  return (
    <div onMouseLeave={handleMouseLeaveButton}>
      <div className="relative group h-10 flex items-center" >
        {/* Dropdown Button */}
        <button
          className="text-gray-800 hover:text-[#5A27E7] transition duration-150 font-semibold"
          onMouseEnter={handleMouseEnterButton}
        >
          {label}
        </button>

        {/* Dropdown Menu */}
        {isOpen && (
            <div
              className="absolute bottom-[-100%] left-[50%] h-full mt-6 w-full bg-transparent rounded-md"
              onMouseEnter={handleMouseEnterButton}
            >
              {/* Triangle Pointer */}
              <div
              className='shadow-lg'
                style={{
                  position: 'absolute',
                  top: '0',
                  left: '0',
                  transform: 'translateX(-50%)',
                  width: '0',
                  height: '0',
                  borderLeft: '20px solid transparent',
                  borderRight: '20px solid transparent',
                  borderBottom: '20px solid white',
                }}
              />
          </div>
        )}
      </div>

      {/* AppBarMenu Outside of the Dropdown */}
      {isOpen && <div className="absolute top-[75px] left-0 w-[100%]" onMouseEnter={handleMouseEnterMenu}
        onMouseLeave={handleMouseLeaveMenu}>
        <AppBarMenu title={heading} menuItems={items} />
      </div>}
    </div>
  );
}

export default DropDown;
